import React from 'react';
import { Link } from 'react-router-dom';

const CheckoutCancel: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="max-w-lg w-full bg-white rounded-2xl shadow-sm border border-gray-200 p-8">
        <h1 className="text-2xl font-bold text-gray-900">Checkout Canceled</h1>
        <p className="mt-2 text-gray-600">
          No worries—your payment wasn’t completed and no account was created. You can try again anytime.
        </p>

        <div className="mt-6 flex flex-col sm:flex-row gap-3">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
          >
            Back to Home
          </Link>
          <a
            href="mailto:support@vectorperformance.ie"
            className="inline-flex items-center justify-center px-6 py-3 border border-gray-200 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
            aria-label="Email support"
          >
            Email Support
          </a>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCancel;

